export enum EControlHandleEvents {
    delete = 'delete',
    edit = 'edit',
    replace = 'replace',
    setting = 'setting',
    copy = 'copy',
    imageEdit = 'image edit',
    addSubMenu = 'addSubMenu',
    catalog = 'catalog',
}
